export enum STORAGE_KEYS {
  accessToken = 'accessToken',
  youRecentlyViewed = 'youRecentlyViewed',
  cookies = 'cookies',
  confirmationData = 'confirmationData',
  currency = 'currency',
  // only app
  visitedWelcomeScreen = 'visitedWelcomeScreen'
}
